import axios from "axios";

export const state = {
    subscriptions: [],
};

export const getters = {
    subscriptions: state => state.subscriptions,
};

export const mutations = {
    setSubscriptions(state, newValue) {
        state.subscriptions = newValue
    },
}; 

export const actions = {
    async fetchSubscriptions({ commit }) {
        await axios.get('/subscriptions').then(res => {
            commit('setSubscriptions', res.data.subscriptions);
        })
    },
};
